// Central site config & static content for Nari Arogya

export const SITE = {
  name: "Nari Arogya",
  tagline: "Ayurveda for Women's Health & Fertility",
  subtag: "Natural. Personalized. Evidence-informed Ayurvedic Care.",
  doctor: "Dr. Anita Chaudhari",
  credentials: "MS (Ayu) Obstetrics & Gynecology",
  role: "Ayurvedic Gynecologist & Fertility Specialist",
  phone: "+91 96997 37675",
  whatsapp: "919699737675",
  email: "nariarogyaayurveda@gmail.com",
  address: {
    line1: "Shop No. 07, Veronica Apartment",
    line2: "Near Sankalpa Siddhi Hanuman Mandir, Paud Road",
    line3: "Right Bhusari Colony, Kothrud",
    city: "Pune",
    state: "Maharashtra",
    pincode: "411038",
  },
  logo: "https://customer-assets.emergentagent.com/job_clinic-builder-13/artifacts/of5prjr1_IMG_20260511_164910.jpg",
  doctorPhoto: "https://customer-assets.emergentagent.com/job_clinic-builder-13/artifacts/4y1oliih_DocScanner%2023-Feb-2026%203-15%20pm.jpg",
  mapEmbed: "https://www.google.com/maps?q=Nari+Arogya+Ayurvedic+Gynecologist+Kothrud+Pune&output=embed",
  gmbUrl: "https://share.google/islos1w0QofeSd6zA",
  socials: {
    instagram: "https://www.instagram.com/nariarogya",
    facebook: "https://facebook.com/nariarogya",
    youtube: "https://youtube.com/@nariarogya",
  },
};

export const GALLERY = [
  {
    src: "https://customer-assets.emergentagent.com/job_clinic-builder-13/artifacts/6vhb6o8a_IMG-20260516-WA0005.jpg",
    caption: "Clinic Entrance",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_clinic-builder-13/artifacts/m99js9f0_IMG-20260516-WA0007.jpg",
    caption: "Services & Timings",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_clinic-builder-13/artifacts/t21swojq_IMG-20260516-WA0006.jpg",
    caption: "Reception Area",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_clinic-builder-13/artifacts/eqogetjz_IMG-20260516-WA0013.jpg",
    caption: "Consultation Room",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_clinic-builder-13/artifacts/1zpit3ox_IMG-20260516-WA0011.jpg",
    caption: "Examination Room",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_clinic-builder-13/artifacts/qlb87cgj_IMG_20260708_104433.webp",
    caption: "Procedure Room",
    wide: true,
  },
];

export const NAV = [
  { label: "Home", to: "/" },
  { label: "About Doctor", to: "/about" },
  { label: "Treatments", to: "/treatments" },
  { label: "Blog", to: "/blog" },
  { label: "FAQs", to: "/faqs" },
  { label: "Contact", to: "/contact" },
];

export const TREATMENTS = [
  { slug: "infertility", title: "Infertility Treatment", icon: "Sparkles", short: "Time-tested Ayurvedic protocols to restore fertility naturally." },
  { slug: "pcos", title: "PCOS Treatment", icon: "Flower2", short: "Hormonal balance & cycle regulation through diet, herbs and Panchakarma." },
  { slug: "irregular-periods", title: "Irregular Periods", icon: "Moon", short: "Restore healthy menstrual rhythm with personalized care." },
  { slug: "menstrual-disorders", title: "Menstrual Disorders", icon: "Droplet", short: "Treatment for heavy, painful or missed cycles." },
  { slug: "low-amh", title: "Low AMH", icon: "Leaf", short: "Ovarian reserve support with Rasayana therapy & nutrition." },
  { slug: "tubal-blockage", title: "Tubal Blockage", icon: "Wind", short: "Uttarbasti and internal medicine to open tubal patency." },
  { slug: "endometriosis", title: "Endometriosis", icon: "Shield", short: "Pain relief and healing through classical Ayurveda." },
  { slug: "pregnancy-care", title: "Pregnancy Care", icon: "HeartPulse", short: "Antenatal Ayurvedic care month-by-month for a healthy pregnancy." },
  { slug: "preconception-counselling", title: "Preconception Counselling", icon: "Compass", short: "Prepare mind and body 3-6 months before conception." },
  { slug: "garbha-sanskar", title: "Garbha Sanskar", icon: "BookHeart", short: "Nurture your baby's mind, body and soul from the womb." },
  { slug: "menopause-care", title: "Menopause Care", icon: "Sun", short: "Ease the transition with herbs, diet and lifestyle." },
  { slug: "post-delivery-care", title: "Post Delivery Care", icon: "Baby", short: "Sutika paricharya for full recovery and lifelong wellness." },
];

export const WHY_US = [
  { title: "Natural Treatment", desc: "Authentic Ayurvedic herbs, therapies, and lifestyle guidance — no shortcuts." },
  { title: "Personalized Care", desc: "Every prakriti is unique. Your plan is built around you." },
  { title: "Evidence-informed", desc: "Classical Ayurveda combined with modern diagnostics and reports." },
  { title: "Holistic Wellness", desc: "Body, mind and emotional well-being — treated together." },
  { title: "Fertility Expertise", desc: "Years of experience helping couples conceive naturally." },
  { title: "Modern + Classical", desc: "Latest tests + time-tested Ayurveda for the best outcomes." },
];

export const TESTIMONIALS = [
  {
    name: "Esha Singh",
    location: "Google Review · 5 reviews",
    rating: 5,
    text: "Excellent experience. Dr. Anita Chaudhari is very knowledgeable and supportive. The treatment approach is natural and focused on long-term health.",
  },
  {
    name: "CA. Suraj Malpani",
    location: "Google Review · 3 reviews",
    rating: 5,
    text: "Suggested many friends and relatives to Nari Arogya Clinic and all thanked me for recommending it. One of the best Ayurvedic Solution Clinic! Highly recommend.",
  },
  {
    name: "Priyanka Singh",
    location: "Google Review · 2 reviews",
    rating: 5,
    text: "One of the best gynecology clinics in Kothrud for Ayurvedic treatment of PCOS, fertility issues, and menstrual problems. Dr. Anita Chaudhari is very knowledgeable and explains everything clearly. Highly recommended.",
  },
  {
    name: "Verified Patient",
    location: "Google Review · Fertility",
    rating: 5,
    text: "I had a very good experience with this doctor for my fertility treatment. The approach is thoughtful and the results speak for themselves.",
  },
  {
    name: "Verified Patient",
    location: "Google Review · Consultation",
    rating: 5,
    text: "She listens patiently and explains the problem in detail. That level of care is rare and truly appreciated.",
  },
  {
    name: "Verified Patient",
    location: "Google Review · Holistic Care",
    rating: 5,
    text: "What I liked most about Nari Arogya Ayurveda clinic is the holistic approach — mind, body and lifestyle addressed together.",
  },
];

export const BLOG = [
  {
    slug: "prepare-healthy-pregnancy",
    title: "How to Prepare for a Healthy Pregnancy Naturally: A Complete Guide",
    metaTitle: "How to Prepare for a Healthy Pregnancy Naturally: A Complete Guide",
    metaDescription: "Prepare your body for pregnancy naturally — preconception care, nutrition, exercise, stress management and Ayurvedic guidance from Dr. Anita Chaudhari, Pune.",
    excerpt: "A healthy pregnancy begins before conception. Discover a natural, Ayurveda-informed preconception plan — nutrition, key nutrients, exercise, stress, and mindful routines.",
    date: "Mar 25, 2026",
    read: "12 min read",
    tag: "Pregnancy",
    cover: "https://customer-assets.emergentagent.com/job_clinic-builder-13/artifacts/epzhklip_file_00000000ea7472088b5c9948a52af4ab.png",
    fromOwner: true,
    body: [
      { type: "p", text: "Pregnancy is one of the most beautiful journeys in a woman's life, and preparing your body before conception can significantly improve the chances of a healthy pregnancy and a healthy baby. While many couples focus only on getting pregnant, the preconception period — the 3 to 6 months before conception — is equally important." },
      { type: "p", text: "Both modern medicine and Ayurveda emphasize that a healthy pregnancy begins well before conception. Proper nutrition, a healthy lifestyle, stress management, and timely medical evaluation help create the best environment for conception." },
      { type: "p", text: "In this article, we'll explore natural ways to prepare for pregnancy, including preconception counseling, nutrition, exercise, and Ayurvedic guidance." },

      { type: "h2", text: "What Is Preconception Care?" },
      { type: "p", text: "Preconception care refers to the healthcare, lifestyle modifications, and nutritional preparation undertaken before trying to conceive. Its goals are to:" },
      { type: "ul", items: [
        "Improve fertility",
        "Identify and treat existing health problems",
        "Reduce pregnancy complications",
        "Promote healthy fetal development",
        "Improve maternal health",
      ]},
      { type: "p", text: "Ideally, couples should begin preconception planning at least 3 months before trying for pregnancy, though 6 months is even better." },

      { type: "h2", text: "Why Is Preconception Counseling Important?" },
      { type: "p", text: "Many conditions affecting fertility and pregnancy can be detected and managed before conception. A preconception consultation typically includes:" },
      { type: "food", num: "1", name: "Medical History", desc: "Your doctor may discuss:",
        bullets: [
          "Menstrual history",
          "Previous pregnancies or miscarriages",
          "Chronic medical conditions",
          "Thyroid disorders",
          "Diabetes",
          "Hypertension",
          "PCOS",
          "Endometriosis",
          "Previous surgeries",
          "Family history of genetic disorders",
        ]},
      { type: "food", num: "2", name: "Lifestyle Assessment", desc: "Important factors include:",
        bullets: ["Body weight", "Sleep quality", "Stress levels", "Smoking", "Alcohol consumption", "Physical activity", "Dietary habits"] },
      { type: "food", num: "3", name: "Essential Health Check-ups", desc: "Depending on your medical history, your doctor may recommend:",
        bullets: [
          "Complete blood count (CBC)",
          "Blood sugar levels",
          "Thyroid profile",
          "Vitamin D",
          "Vitamin B12",
          "Iron status",
          "Blood group",
          "Rubella immunity",
          "Urine examination",
          "Pap smear (if due)",
          "STI screening (when indicated)",
        ]},

      { type: "h2", text: "Nutrition for a Healthy Pregnancy" },
      { type: "p", text: "Nutrition before pregnancy directly influences fertility, egg quality, hormonal balance, and fetal development." },
      { type: "food", num: "1", name: "Whole Grains", desc: "Millets, brown rice, whole wheat and oats provide sustained energy and fiber." },
      { type: "food", num: "2", name: "Protein-Rich Foods", desc: "Include moong dal, lentils, chickpeas, paneer, milk, curd, eggs (if consumed) and lean meats (if consumed). Protein supports hormone production and healthy egg development." },
      { type: "food", num: "3", name: "Healthy Fats", desc: "Choose ghee (in moderation), nuts, seeds, coconut and avocado. Healthy fats are essential for reproductive hormones." },
      { type: "food", num: "4", name: "Fresh Fruits and Vegetables", desc: "Aim for a variety of colorful fruits and vegetables every day to provide vitamins, minerals, antioxidants and fiber. Antioxidants help protect eggs from oxidative stress." },

      { type: "h2", text: "Key Nutrients Before Pregnancy" },
      { type: "food", num: "1", name: "Folic Acid", desc: "One of the most important nutrients before conception. It helps prevent neural tube defects in the developing baby.",
        bullets: ["Spinach", "Broccoli", "Citrus fruits", "Beans"],
        tag: "Note", tagText: "Your healthcare provider may also recommend folic acid supplementation before conception." },
      { type: "food", num: "2", name: "Iron", desc: "Helps prevent anemia and supports healthy pregnancy.",
        bullets: ["Green leafy vegetables", "Dates", "Raisins", "Jaggery (in moderation)", "Lentils", "Sesame seeds"] },
      { type: "food", num: "3", name: "Calcium", desc: "Supports healthy bones and teeth.",
        bullets: ["Milk", "Curd", "Paneer", "Ragi", "Sesame seeds"] },
      { type: "food", num: "4", name: "Vitamin D", desc: "Supports fertility, immunity, and bone health.",
        bullets: ["Morning sunlight", "Fortified foods", "Supplements if prescribed"] },
      { type: "food", num: "5", name: "Omega-3 Fatty Acids", desc: "Support fetal brain development and reproductive health.",
        bullets: ["Flaxseeds", "Walnuts", "Chia seeds", "Fatty fish (if consumed)"] },

      { type: "h2", text: "Foods to Limit Before Pregnancy" },
      { type: "p", text: "Reduce or avoid the following, as they may negatively affect fertility and overall health:" },
      { type: "ul", items: [
        "Processed foods",
        "Sugary beverages",
        "Deep-fried foods",
        "Excess refined sugar",
        "Excess caffeine",
        "Alcohol",
        "Tobacco products",
      ]},

      { type: "h2", text: "Maintain a Healthy Weight" },
      { type: "p", text: "Being either underweight or overweight may affect:" },
      { type: "ul", items: ["Ovulation", "Hormonal balance", "Fertility", "Pregnancy outcomes"] },
      { type: "p", text: "A healthy body weight supports regular menstrual cycles and improves the chances of conception." },

      { type: "h2", text: "Exercise Before Pregnancy" },
      { type: "p", text: "Regular physical activity improves overall reproductive health. Benefits include:" },
      { type: "ul", items: ["Better hormonal balance", "Improved insulin sensitivity", "Reduced stress", "Better circulation", "Healthy body weight", "Improved sleep"] },
      { type: "p", text: "Aim for about 150 minutes of moderate physical activity per week, unless advised otherwise by your healthcare provider. Suitable activities include:" },
      { type: "ul", items: ["Brisk walking", "Yoga", "Swimming", "Cycling", "Light strength training", "Stretching exercises"] },
      { type: "p", text: "Avoid excessive or very intense exercise if you are underweight or have specific fertility concerns." },

      { type: "h2", text: "Stress Management" },
      { type: "p", text: "Chronic stress may affect hormonal balance and menstrual regularity. Helpful practices include:" },
      { type: "ul", items: [
        "Meditation",
        "Deep breathing exercises",
        "Yoga",
        "Spending time in nature",
        "Reading",
        "Listening to calming music",
        "Maintaining healthy relationships",
      ]},
      { type: "p", text: "Adequate sleep (7–9 hours per night) also supports hormonal health." },

      { type: "h2", text: "Ayurvedic Guidance Before Conception" },
      { type: "p", text: "Ayurveda places great importance on preparing the body before conception to promote the health of both mother and baby. According to Ayurveda, healthy conception depends on:" },
      { type: "ul", items: [
        "Healthy reproductive tissues (Shukra and Artava)",
        "Proper digestion (Agni)",
        "Balanced Doshas (Vata, Pitta, Kapha)",
        "Good mental and emotional well-being",
      ]},

      { type: "food", num: "1", name: "Panchakarma (When Appropriate)", desc: "For selected individuals, an Ayurvedic physician may recommend purification therapies before conception to help improve overall health and prepare the body. These treatments should always be individualized and performed under qualified supervision." },
      { type: "food", num: "2", name: "Improve Digestive Health", desc: "Ayurveda emphasizes strong digestion (Agni) as the foundation of health.",
        bullets: [
          "Eat freshly prepared meals",
          "Avoid overeating",
          "Eat at regular times",
          "Limit processed foods",
          "Include digestive spices such as cumin, coriander, and fennel as appropriate",
        ]},
      { type: "food", num: "3", name: "Daily Routine (Dinacharya)", desc: "A balanced daily routine may include:",
        bullets: ["Waking early", "Regular meal timings", "Gentle exercise", "Yoga", "Meditation", "Adequate sleep"],
        tag: "Note", tagText: "Consistency supports hormonal balance and overall wellness." },
      { type: "food", num: "4", name: "Rasayana Support", desc: "Depending on an individual's constitution and health status, an Ayurvedic physician may recommend specific Rasayana (rejuvenative) therapies or herbs to support reproductive health.",
        tag: "Important", tagText: "These should only be taken after professional consultation, as self-medication is not recommended." },
      { type: "food", num: "5", name: "Mental Well-being", desc: "Ayurveda recognizes the importance of emotional health before conception. Helpful practices include:",
        bullets: ["Positive thinking", "Prayer or mindfulness", "Spending quality time with family", "Reducing anxiety", "Practicing gratitude"] },

      { type: "h2", text: "Habits That Improve Fertility Naturally" },
      { type: "ul", items: [
        "Eat a balanced, nutrient-rich diet.",
        "Stay physically active.",
        "Maintain a healthy weight.",
        "Sleep 7–9 hours daily.",
        "Manage stress effectively.",
        "Avoid smoking, alcohol, and recreational drugs.",
        "Stay hydrated.",
        "Track menstrual cycles and ovulation if trying to conceive.",
        "Attend regular health check-ups.",
      ]},

      { type: "h2", text: "When Should You Consult a Doctor?" },
      { type: "p", text: "Seek medical advice if:" },
      { type: "warn_list", items: [
        "You are younger than 35 years and have been trying to conceive for 12 months without success.",
        "You are 35 years or older and have been trying for 6 months without success.",
        "Your menstrual cycles are irregular or absent.",
        "You have severe pelvic pain or painful periods.",
        "You have a history of recurrent miscarriages.",
        "You have known conditions such as PCOS, endometriosis, thyroid disorders, or diabetes.",
      ]},
      { type: "p", text: "Early evaluation can help identify treatable causes and improve pregnancy outcomes." },

      { type: "h2", text: "Frequently Asked Questions" },
      { type: "faq", q: "Can Ayurveda improve fertility naturally?", a: "Ayurveda focuses on optimizing overall health, digestion, lifestyle, and reproductive wellness. Individualized treatment under a qualified Ayurvedic physician may help support fertility alongside appropriate medical care." },
      { type: "faq", q: "How long should I prepare before pregnancy?", a: "Ideally, begin preparing 3–6 months before trying to conceive to optimize nutrition, lifestyle, and overall health." },
      { type: "faq", q: "Is exercise safe while trying to conceive?", a: "Yes. Moderate, regular exercise is generally beneficial for fertility and overall health. Your healthcare provider can advise you if you have specific medical conditions." },
      { type: "faq", q: "Which vitamin is most important before pregnancy?", a: "Folic acid is one of the most important nutrients before conception, and your healthcare provider may recommend supplementation in addition to a healthy diet." },

      { type: "h2", text: "Conclusion" },
      { type: "p", text: "Preparing for pregnancy is about much more than achieving conception. Building healthy habits before pregnancy — through balanced nutrition, regular exercise, stress management, and individualized preconception care — creates the best foundation for maternal health and fetal development." },
      { type: "p", text: "Ayurveda complements modern preconception care by emphasizing holistic wellness, digestive health, balanced lifestyle practices, and personalized guidance. Consulting a qualified healthcare professional before conception can help you enter pregnancy with greater confidence and better overall health." },

      { type: "disclaimer", text: "This article is intended for educational purposes only and should not replace personalized medical advice. Always consult a qualified healthcare professional or an experienced Ayurvedic gynecologist before starting any treatment, supplements, or herbal medicines, especially if you have an existing medical condition or are planning pregnancy." },
    ],
  },
  {
    slug: "white-discharge-leucorrhea",
    title: "White Discharge (Leucorrhea): When Is It Normal and When Should You See a Doctor?",
    metaTitle: "White Discharge (Leucorrhea): Normal or Abnormal? Ayurvedic Guide",
    metaDescription: "Learn when white discharge is normal, when to worry, and how Ayurveda approaches leucorrhea (Shweta Pradara) through root-cause care and lifestyle guidance.",
    excerpt: "Not every white discharge is a sign of disease. Learn what's normal, when to consult a doctor, and how Ayurveda addresses Shweta Pradara through root-cause care.",
    date: "Mar 20, 2026",
    read: "10 min read",
    tag: "Women's Health",
    cover: "https://customer-assets.emergentagent.com/job_clinic-builder-13/artifacts/81wf99du_file_00000000c4647208b6def26f9fd52fbb.png",
    fromOwner: true,
    body: [
      { type: "p", text: "White vaginal discharge, medically known as leucorrhea, is one of the most common concerns among women of all ages. Many women worry that every episode of white discharge is a sign of disease. However, the truth is that not all white discharge is abnormal. In many cases, it is a natural process that helps keep the vagina healthy." },
      { type: "p", text: "Understanding the difference between normal and abnormal discharge can help you seek timely treatment and maintain good reproductive health. Ayurveda also offers a holistic approach to managing abnormal white discharge by treating its root cause rather than simply controlling the symptoms." },

      { type: "h2", text: "What Is White Discharge?" },
      { type: "p", text: "White discharge is a fluid naturally produced by the glands of the cervix and vagina. It helps to:" },
      { type: "ul", items: [
        "Keep the vagina clean",
        "Maintain healthy vaginal flora",
        "Prevent infections",
        "Provide natural lubrication",
        "Protect the reproductive organs",
      ]},
      { type: "p", text: "The amount, consistency, and color of discharge vary depending on hormonal changes during the menstrual cycle." },

      { type: "h2", text: "When Is White Discharge Normal?" },
      { type: "p", text: "Physiological (normal) white discharge is:" },
      { type: "ul", items: [
        "Clear or milky white",
        "Thin or slightly thick",
        "Odorless or has a mild smell",
        "Does not cause itching, burning, or pain",
      ]},
      { type: "p", text: "It commonly increases during:" },
      { type: "routine_list", items: [
        { name: "Ovulation", desc: "Hormonal changes increase cervical mucus, making the discharge stretchy and slippery." },
        { name: "Before Menstruation", desc: "Progesterone causes discharge to become thicker." },
        { name: "Pregnancy", desc: "Increased estrogen and blood flow lead to more vaginal discharge." },
        { name: "Sexual Arousal", desc: "Natural lubrication increases." },
        { name: "Stress and Hormonal Changes", desc: "Temporary changes in hormones may increase discharge." },
      ]},
      { type: "p", text: "This type of discharge does not require treatment." },

      { type: "h2", text: "When Is White Discharge Abnormal?" },
      { type: "p", text: "Consult a doctor if the discharge is accompanied by:" },
      { type: "warn_list", items: [
        "Yellow, green, or gray color",
        "Thick, curd-like (cottage cheese) appearance",
        "Foul or fishy smell",
        "Severe itching",
        "Burning sensation",
        "Pain during urination",
        "Pain during intercourse",
        "Lower abdominal pain",
        "Fever",
        "Blood-stained discharge (not related to menstruation)",
      ]},
      { type: "p", text: "These symptoms may indicate an infection or another gynecological condition." },

      { type: "h2", text: "Common Causes of Abnormal White Discharge" },
      { type: "food", num: "1", name: "Fungal Infection (Candidiasis)", desc: "Common signs and risk factors:",
        bullets: ["Thick white discharge", "Intense itching", "Redness", "Burning sensation"],
        tag: "Risk factors", tagText: "Diabetes, pregnancy, antibiotic use, low immunity." },
      { type: "food", num: "2", name: "Bacterial Vaginosis", desc: "Occurs due to an imbalance of healthy vaginal bacteria.",
        bullets: ["Thin gray-white discharge", "Fishy odor", "Mild irritation"] },
      { type: "food", num: "3", name: "Sexually Transmitted Infections (STIs)", desc: "Chlamydia, gonorrhea, and trichomoniasis can cause:",
        bullets: ["Yellow or green discharge", "Bad odor", "Pelvic pain", "Pain during urination"],
        tag: "Note", tagText: "Prompt medical evaluation is essential." },
      { type: "food", num: "4", name: "Cervical Infection", desc: "Inflammation of the cervix may cause:",
        bullets: ["Persistent discharge", "Spotting after intercourse", "Pelvic discomfort"] },
      { type: "food", num: "5", name: "Hormonal Imbalance", desc: "Conditions like PCOS, pregnancy, menopause, and thyroid disorders may alter vaginal discharge." },
      { type: "food", num: "6", name: "Poor Intimate Hygiene", desc: "Poor hygiene, prolonged dampness, or wearing tight synthetic clothing can increase the risk of infections." },
      { type: "food", num: "7", name: "Diabetes", desc: "High blood sugar encourages fungal growth, leading to recurrent vaginal infections." },

      { type: "h2", text: "Risk Factors" },
      { type: "p", text: "You may be at higher risk if you have:" },
      { type: "ul", items: [
        "Poor genital hygiene",
        "Uncontrolled diabetes",
        "Pregnancy",
        "Obesity",
        "Frequent antibiotic use",
        "Hormonal imbalance",
        "Low immunity",
        "High stress",
        "Multiple sexual partners",
      ]},

      { type: "h2", text: "Prevention Tips" },
      { type: "p", text: "Maintaining healthy vaginal hygiene can reduce the risk of infections." },
      { type: "routine_list", items: [
        { name: "Maintain Good Hygiene", desc: "Wash the genital area with clean water. Avoid harsh soaps and scented products. Wipe from front to back after using the toilet." },
        { name: "Wear Breathable Clothing", desc: "Choose loose-fitting cotton underwear and avoid tight synthetic garments." },
        { name: "Change Wet Clothes Promptly", desc: "Avoid staying in sweaty workout clothes or wet swimsuits for long periods." },
        { name: "Practice Safe Sex", desc: "Use protection and undergo regular health check-ups if needed." },
        { name: "Control Blood Sugar", desc: "Women with diabetes should maintain good glucose control to reduce recurrent infections." },
      ]},
      { type: "season", name: "Eat & Avoid for Vaginal Health", icon: "Utensils",
        eat: ["Fresh fruits", "Green leafy vegetables", "Yogurt (if suitable)", "Whole grains", "Plenty of water"],
        avoid: ["Excess sugar", "Refined flour", "Junk food", "Sugary drinks"] },

      { type: "h2", text: "Ayurvedic Perspective" },
      { type: "p", text: "In Ayurveda, abnormal white discharge is often correlated with Shweta Pradara, which is primarily associated with an imbalance of Kapha Dosha and may involve Vata Dosha. Impaired digestion (Agni) and accumulation of Ama (metabolic toxins) can also contribute. The condition is assessed individually based on a woman's constitution, symptoms, and underlying cause." },

      { type: "h2", text: "Ayurvedic Management" },
      { type: "p", text: "Ayurvedic treatment focuses on identifying and addressing the root cause rather than only reducing the discharge. Depending on the individual's condition, an Ayurvedic physician may recommend:" },
      { type: "ul", items: [
        "Personalized herbal medicines",
        "Dietary modifications",
        "Lifestyle correction",
        "Measures to improve digestion (Agni)",
        "Panchakarma therapies, where appropriate and clinically indicated",
      ]},
      { type: "p", text: "The treatment plan varies from person to person and should always be supervised by a qualified Ayurvedic doctor." },

      { type: "h2", text: "Lifestyle Tips" },
      { type: "ul", items: [
        "Sleep 7–8 hours daily.",
        "Exercise regularly.",
        "Practice yoga and meditation to manage stress.",
        "Maintain a healthy weight.",
        "Avoid self-medication.",
        "Complete any prescribed treatment course.",
        "Attend regular gynecological check-ups.",
      ]},

      { type: "h2", text: "When Should You See a Doctor?" },
      { type: "p", text: "Seek medical advice immediately if you experience:" },
      { type: "warn_list", items: [
        "Persistent white discharge lasting more than 1–2 weeks",
        "Foul-smelling discharge",
        "Severe itching or burning",
        "Green, yellow, or bloody discharge",
        "Pelvic or lower abdominal pain",
        "Fever",
        "Pain during intercourse",
        "Recurrent vaginal infections",
        "White discharge during pregnancy accompanied by itching, odor, pain, bleeding, or leaking of fluid",
      ]},
      { type: "p", text: "Early diagnosis can help prevent complications and ensure appropriate treatment." },

      { type: "h2", text: "Frequently Asked Questions" },
      { type: "faq", q: "Is white discharge always a sign of infection?", a: "No. Normal white discharge is a healthy part of the body's natural cleansing process." },
      { type: "faq", q: "Can stress increase white discharge?", a: "Yes. Hormonal changes associated with stress may temporarily increase vaginal discharge." },
      { type: "faq", q: "Can PCOS cause white discharge?", a: "Hormonal changes in PCOS may influence vaginal discharge, but persistent or abnormal discharge should be evaluated to rule out infection or other conditions." },
      { type: "faq", q: "Can Ayurveda cure leucorrhea permanently?", a: "Ayurveda aims to identify and manage the underlying cause while improving overall reproductive health. The outcome depends on the cause, severity, and adherence to treatment, and should be guided by a qualified Ayurvedic physician." },

      { type: "h2", text: "Conclusion" },
      { type: "p", text: "White discharge is often a normal and healthy part of a woman's reproductive cycle. However, changes in color, odor, quantity, or associated symptoms such as itching, burning, or pelvic pain should not be ignored. Good hygiene, a balanced lifestyle, and timely medical evaluation can help maintain vaginal health. Ayurveda offers a holistic approach to supporting women's reproductive wellness by addressing underlying imbalances through individualized care." },

      { type: "disclaimer", text: "This article is for educational purposes only and should not be considered medical advice. Always consult a qualified gynecologist or Ayurvedic physician for proper diagnosis and personalized treatment." },
    ],
  },
  {
    slug: "painful-periods-dysmenorrhea",
    title: "Painful Periods (Dysmenorrhea): Causes and Ayurvedic Solutions",
    metaTitle: "Painful Periods (Dysmenorrhea): Causes, Symptoms & Ayurvedic Treatment",
    metaDescription: "Learn about the causes of painful periods, effective home remedies, Ayurvedic treatment options, and when to consult a gynecologist. Discover natural ways to manage menstrual pain.",
    excerpt: "Menstrual pain that interferes with your life is not something you have to endure. Understand dysmenorrhea, its causes, and how Ayurveda offers long-term relief naturally.",
    date: "Mar 15, 2026",
    read: "10 min read",
    tag: "Menstrual Health",
    cover: "https://customer-assets.emergentagent.com/job_clinic-builder-13/artifacts/25dt8m83_file_00000000e1a472089a417d6ac956c7d5.png",
    fromOwner: true,
    body: [
      { type: "p", text: "Menstrual pain, medically known as dysmenorrhea, is one of the most common concerns affecting women of all ages. While mild discomfort during periods is normal, severe pain that interferes with daily activities should never be ignored." },
      { type: "p", text: "Many women rely on painkillers every month, but frequent medication only provides temporary relief without addressing the underlying cause. Ayurveda offers a holistic approach by identifying the root imbalance and restoring healthy menstrual function naturally." },
      { type: "p", text: "In this article, we'll explore the causes of painful periods, natural home remedies, Ayurvedic treatment options, and signs that indicate you should consult a gynecologist." },

      { type: "h2", text: "What is Dysmenorrhea?" },
      { type: "p", text: "Dysmenorrhea refers to painful menstrual cramps that occur before or during menstruation. The pain is usually felt in the lower abdomen but may also radiate to the lower back, hips, and thighs." },
      { type: "p", text: "Common symptoms include:" },
      { type: "ul", items: [
        "Cramping pain in the lower abdomen",
        "Lower backache",
        "Pain radiating to the thighs",
        "Nausea or vomiting",
        "Loose motions",
        "Headache",
        "Fatigue",
        "Dizziness",
        "Weakness during periods",
      ]},

      { type: "h2", text: "Types of Dysmenorrhea" },
      { type: "food", num: "1", name: "Primary Dysmenorrhea", desc: "This type occurs without any underlying pelvic disease. It usually:",
        bullets: [
          "Starts within a few years after the first period",
          "Is common among teenagers and young women",
          "Is caused by increased prostaglandin production leading to stronger uterine contractions",
        ]},
      { type: "food", num: "2", name: "Secondary Dysmenorrhea", desc: "Pain occurs due to an underlying medical condition such as:",
        bullets: ["Endometriosis", "Adenomyosis", "Uterine fibroids", "Pelvic inflammatory disease (PID)", "Ovarian cysts", "Cervical stenosis"],
        tag: "Note", tagText: "This type often begins later in life and gradually worsens over time." },

      { type: "h2", text: "Common Causes of Painful Periods" },
      { type: "p", text: "Several factors can contribute to menstrual pain." },
      { type: "food", num: "1", name: "Hormonal Changes", desc: "High levels of prostaglandins cause intense uterine contractions resulting in cramps." },
      { type: "food", num: "2", name: "Endometriosis", desc: "In this condition, tissue similar to the uterine lining grows outside the uterus, causing severe pain, painful intercourse, and infertility." },
      { type: "food", num: "3", name: "Adenomyosis", desc: "The uterine lining grows into the muscular wall of the uterus, leading to heavy bleeding and severe cramps." },
      { type: "food", num: "4", name: "Uterine Fibroids", desc: "Non-cancerous growths inside the uterus may cause painful periods, heavy bleeding, and pelvic pressure." },
      { type: "food", num: "5", name: "Pelvic Infections", desc: "Untreated pelvic infections can lead to chronic pelvic pain and painful menstruation." },
      { type: "food", num: "6", name: "Stress and Lifestyle Factors", desc: "Poor sleep, excessive stress, lack of exercise, unhealthy eating habits, and obesity can worsen menstrual pain." },

      { type: "h2", text: "Ayurvedic Perspective" },
      { type: "p", text: "In Ayurveda, painful menstruation is mainly associated with Vata Dosha imbalance, particularly Apana Vata, which governs the downward movement of menstruation." },
      { type: "p", text: "When Vata becomes aggravated due to:" },
      { type: "ul", items: [
        "Irregular meals",
        "Excess fasting",
        "Stress",
        "Lack of sleep",
        "Excessive travel",
        "Cold foods",
        "Dry foods",
      ]},
      { type: "p", text: "the menstrual flow becomes obstructed, resulting in painful cramps." },
      { type: "p", text: "Depending on the individual's constitution, Pitta (causing burning sensation and heavy bleeding) or Kapha (causing congestion and sluggish flow) may also be involved. Therefore, Ayurvedic treatment is always individualized." },

      { type: "h2", text: "Home Remedies for Menstrual Pain" },
      { type: "p", text: "These simple remedies may help reduce mild menstrual cramps." },
      { type: "routine_list", items: [
        { name: "Apply Warm Compress", desc: "Using a hot water bag on the lower abdomen relaxes uterine muscles and improves blood circulation." },
        { name: "Drink Warm Water", desc: "Avoid chilled drinks during menstruation. Warm water helps improve circulation and reduces spasms." },
        { name: "Herbal Tea", desc: "Warm herbal teas made with ginger, cinnamon, fennel, and tulsi can help reduce cramps and bloating." },
        { name: "Gentle Yoga", desc: "Postures such as Child's Pose, Cat-Cow Stretch, Butterfly Pose, and Cobra Pose may relieve pelvic muscle tension." },
        { name: "Light Walking", desc: "A short walk improves circulation and releases natural pain-relieving hormones (endorphins)." },
        { name: "Healthy Diet", desc: "Choose fresh fruits, green leafy vegetables, sesame seeds, nuts, whole grains and warm soups. Avoid junk food, fried foods, excess sugar, soft drinks, ice creams, and excess caffeine." },
      ]},

      { type: "h2", text: "Ayurvedic Treatment Options" },
      { type: "p", text: "Ayurvedic treatment focuses on correcting the root cause rather than simply suppressing pain. The treatment plan depends on the individual's Prakriti, Dosha imbalance, symptoms, and underlying condition. It may include:" },
      { type: "food", num: "1", name: "Personalized Herbal Medicines", desc: "Herbal formulations are selected according to the patient's condition to help:",
        bullets: ["Reduce pain", "Improve menstrual flow", "Balance hormones", "Reduce inflammation", "Support reproductive health"],
        tag: "Important", tagText: "Ayurvedic medicines should only be taken under the guidance of a qualified Ayurvedic physician." },
      { type: "food", num: "2", name: "Panchakarma Therapy", desc: "Selected Panchakarma procedures may be advised in suitable patients to help balance aggravated doshas, improve pelvic circulation, and promote reproductive health." },
      { type: "food", num: "3", name: "Uttar Basti (When Indicated)", desc: "For selected gynecological conditions and only under specialist supervision, Uttar Basti may be considered as part of a comprehensive Ayurvedic treatment plan." },
      { type: "food", num: "4", name: "Diet and Lifestyle Correction", desc: "Ayurveda strongly emphasizes:",
        bullets: ["Regular meal timings", "Adequate sleep", "Stress reduction", "Yoga", "Meditation", "Daily exercise", "Avoiding suppression of natural urges"],
        tag: "Outcome", tagText: "These changes help reduce recurrent menstrual pain over time." },

      { type: "h2", text: "When Should You Seek Medical Advice?" },
      { type: "p", text: "Consult a gynecologist if you experience:" },
      { type: "warn_list", items: [
        "Severe pain every month",
        "Pain that prevents work or school",
        "Heavy menstrual bleeding",
        "Irregular periods",
        "Fever during menstruation",
        "Pain during intercourse",
        "Infertility",
        "Sudden worsening of menstrual pain",
        "Pain not relieved by home remedies",
        "Persistent pelvic pain even after periods",
      ]},
      { type: "p", text: "Early evaluation can help diagnose conditions such as endometriosis, fibroids, adenomyosis, or pelvic infections before complications develop." },

      { type: "h2", text: "Tips to Prevent Painful Periods" },
      { type: "ul", items: [
        "Maintain a healthy body weight.",
        "Exercise regularly.",
        "Manage stress through yoga or meditation.",
        "Eat a balanced, anti-inflammatory diet.",
        "Stay hydrated.",
        "Get 7–8 hours of quality sleep.",
        "Avoid smoking and excessive alcohol.",
        "Follow a regular daily routine.",
      ]},

      { type: "h2", text: "Conclusion" },
      { type: "p", text: "Painful periods should not be accepted as something every woman simply has to endure. While occasional mild cramps are common, severe or recurring menstrual pain may indicate an underlying condition that deserves medical attention." },
      { type: "p", text: "Ayurveda offers a holistic and individualized approach by addressing the root cause, balancing doshas, supporting hormonal health, and improving overall reproductive wellness. Along with appropriate medical evaluation, healthy lifestyle habits and guided Ayurvedic care can help many women achieve long-term relief and a better quality of life." },

      { type: "disclaimer", text: "This article is intended for educational purposes only and should not replace professional medical advice. If you experience severe or persistent menstrual pain, consult a qualified gynecologist or an Ayurvedic physician for a proper diagnosis and personalized treatment." },
    ],
  },
  {
    slug: "hormonal-imbalance-signs",
    title: "Top 10 Early Signs of Hormonal Imbalance Every Woman Should Know",
    excerpt: "Hormones quietly govern your cycles, mood, skin, sleep and fertility. Learn the 10 earliest warning signs — and how Ayurveda restores balance naturally.",
    date: "Mar 10, 2026",
    read: "10 min read",
    tag: "Hormonal Health",
    cover: "https://customer-assets.emergentagent.com/job_clinic-builder-13/artifacts/uvkqb2ww_file_00000000525072088d8d36b05ec6e36c.png",
    fromOwner: true,
    body: [
      { type: "p", text: "Hormones are chemical messengers that regulate nearly every function in a woman's body — from menstrual cycles and fertility to mood, metabolism, skin, and sleep. Even a small imbalance can affect your overall health and quality of life. Recognizing the early signs of hormonal imbalance allows timely treatment and helps prevent long-term complications." },
      { type: "p", text: "In Ayurveda, hormonal imbalance is viewed as a disturbance of the Vata, Pitta, and Kapha doshas, along with imbalance in the Artava Dhatu (female reproductive tissue) and Agni (digestive fire). By restoring the body's natural balance through diet, lifestyle, herbal medicines, and Panchakarma therapies, hormonal health can often be improved naturally." },

      { type: "sign", num: "1", title: "Persistent Acne",
        intro: "Acne that appears repeatedly on the jawline, chin, neck, or lower face may indicate hormonal fluctuations rather than simple skin problems.",
        sections: [
          { label: "Why it happens", text: "Hormonal changes increase androgen levels, stimulating excess oil production that clogs pores and promotes acne." },
          { label: "Common causes", items: ["PCOS", "Puberty", "Menstrual cycle changes", "Pregnancy", "Menopause", "Stress"] },
          { label: "Ayurvedic Perspective", text: "Acne is often associated with aggravated Pitta and impure Rakta Dhatu." },
          { label: "Natural Tips", items: ["Avoid oily, spicy, and processed foods.", "Drink plenty of water.", "Eat fresh fruits and vegetables.", "Manage stress through yoga and meditation."] },
        ]},

      { type: "sign", num: "2", title: "Unexplained Weight Gain",
        intro: "If you are gaining weight despite maintaining the same diet and exercise routine, hormones may be responsible.",
        sections: [
          { label: "Possible hormonal causes", items: ["PCOS", "Hypothyroidism", "Insulin resistance", "High cortisol due to chronic stress"] },
          { label: "Ayurvedic Perspective", text: "Weight gain is commonly linked to increased Kapha Dosha, sluggish metabolism (Mandagni), and accumulation of toxins (Ama)." },
          { label: "Natural Tips", items: ["Eat freshly prepared meals.", "Exercise for at least 30–45 minutes daily.", "Avoid sugary drinks and refined carbohydrates.", "Maintain regular meal timings."] },
        ]},

      { type: "sign", num: "3", title: "Excessive Hair Fall",
        intro: "Losing a few strands daily is normal, but excessive hair shedding may signal hormonal imbalance.",
        sections: [
          { label: "Common hormonal causes", items: ["PCOS", "Thyroid disorders", "Iron deficiency", "Postpartum hormonal changes", "Menopause"] },
          { label: "Ayurvedic Perspective", text: "Hair health depends on balanced Pitta, healthy Rakta Dhatu, and proper nourishment of body tissues." },
          { label: "Natural Tips", items: ["Eat protein-rich foods.", "Maintain adequate iron and vitamin intake.", "Reduce stress.", "Use Ayurvedic scalp oils as advised by your physician."] },
        ]},

      { type: "sign", num: "4", title: "Excess Facial Hair (Hirsutism)",
        intro: "Thick hair growth on the face, chin, upper lip, chest, or abdomen can indicate elevated androgen hormones.",
        sections: [
          { label: "Common causes", items: ["PCOS", "Adrenal disorders", "Hormonal imbalance"] },
          { label: "Associated symptoms", items: ["Irregular periods", "Acne", "Weight gain", "Difficulty conceiving"] },
          { label: "Ayurvedic Perspective", text: "Usually associated with Kapha-Vata imbalance and disturbed metabolism. Early evaluation helps prevent long-term fertility issues." },
        ]},

      { type: "sign", num: "5", title: "Mood Swings and Irritability",
        intro: "Hormones significantly influence brain chemicals that regulate emotions.",
        sections: [
          { label: "Symptoms include", items: ["Irritability", "Anxiety", "Depression", "Sudden anger", "Emotional sensitivity"] },
          { label: "Common causes", items: ["PMS", "Pregnancy", "Perimenopause", "Menopause", "Thyroid disorders"] },
          { label: "Ayurvedic Perspective", text: "Aggravated Vata Dosha often causes emotional instability and anxiety." },
          { label: "Natural Tips", items: ["Practice meditation.", "Maintain regular sleep.", "Reduce caffeine.", "Spend time outdoors."] },
        ]},

      { type: "sign", num: "6", title: "Sleep Disturbances",
        intro: "Difficulty falling asleep, frequent night awakenings, or poor-quality sleep may be linked to hormonal changes. Poor sleep can further worsen hormonal imbalance, creating a vicious cycle.",
        sections: [
          { label: "Possible hormonal causes", items: ["Menopause", "Thyroid imbalance", "High cortisol", "Stress", "PCOS"] },
          { label: "Ayurvedic Perspective", text: "Sleep disturbances are commonly related to aggravated Vata Dosha." },
          { label: "Natural Tips", items: ["Avoid screens before bedtime.", "Sleep at the same time every night.", "Drink warm milk if suitable.", "Practice deep breathing exercises."] },
        ]},

      { type: "sign", num: "7", title: "Irregular Menstrual Cycles",
        intro: "One of the earliest indicators of hormonal imbalance is a change in menstrual regularity.",
        sections: [
          { label: "You may notice", items: ["Delayed periods", "Missed periods", "Heavy bleeding", "Very light bleeding", "Short or long cycles"] },
          { label: "Possible causes", items: ["PCOS", "Thyroid disorders", "Stress", "Perimenopause", "Excessive exercise"] },
          { label: "Note", text: "Early diagnosis improves reproductive health and fertility outcomes." },
        ]},

      { type: "sign", num: "8", title: "Fatigue and Low Energy",
        intro: "Constant tiredness despite adequate rest should not be ignored.",
        sections: [
          { label: "Possible causes", items: ["Thyroid disorders", "Low estrogen", "Poor sleep", "Chronic stress", "Anemia"] },
          { label: "Ayurvedic Perspective", text: "Weak digestion, low vitality, and tissue depletion can contribute to persistent fatigue." },
        ]},

      { type: "sign", num: "9", title: "Reduced Fertility",
        intro: "Hormonal imbalance can interfere with ovulation, making conception more difficult.",
        sections: [
          { label: "Warning signs", items: ["Irregular ovulation", "Irregular periods", "PCOS", "Luteal phase defects", "Recurrent pregnancy loss"] },
          { label: "Note", text: "Preconception evaluation can identify and address many treatable hormonal issues." },
        ]},

      { type: "sign", num: "10", title: "Low Libido",
        intro: "A noticeable decline in sexual desire may result from hormonal changes affecting estrogen, progesterone, testosterone, or thyroid hormones.",
        sections: [
          { label: "Other contributing factors", items: ["Stress", "Fatigue", "Poor sleep", "Relationship concerns", "Certain medications"] },
          { label: "Note", text: "A comprehensive evaluation helps determine the underlying cause." },
        ]},

      { type: "h2", text: "When Should You See a Doctor?" },
      { type: "p", text: "Consult a gynecologist if you experience:" },
      { type: "warn_list", items: [
        "Persistent irregular periods",
        "Acne that does not improve",
        "Excessive hair growth",
        "Unexplained weight changes",
        "Hair fall lasting several months",
        "Difficulty conceiving after trying",
        "Severe mood changes",
        "Persistent fatigue",
        "Sleep problems affecting daily life",
      ]},
      { type: "p", text: "Early diagnosis allows appropriate treatment before complications develop." },

      { type: "h2", text: "How Ayurveda Supports Hormonal Balance" },
      { type: "p", text: "Ayurveda focuses on identifying the root cause rather than only managing symptoms. Treatment is individualized and may include:" },
      { type: "ul", items: [
        "Personalized dietary guidance",
        "Lifestyle modifications (Dinacharya)",
        "Herbal formulations prescribed according to your constitution",
        "Panchakarma therapies when indicated",
        "Stress management through Yoga and Pranayama",
        "Weight management and metabolic correction",
        "Fertility-supportive care for women planning pregnancy",
      ]},

      { type: "h2", text: "Final Thoughts" },
      { type: "p", text: "Hormonal imbalance can affect women at any stage of life — from adolescence to menopause. Symptoms such as acne, weight gain, hair fall, excess facial hair, mood swings, sleep disturbances, irregular periods, fatigue, infertility, and reduced libido should not be ignored. Recognizing these early warning signs and seeking timely medical evaluation can help restore hormonal balance and improve overall health." },
      { type: "p", text: "If you notice one or more of these symptoms, consult a qualified gynecologist or Ayurvedic physician for a comprehensive assessment and personalized treatment plan. Early intervention often leads to better long-term health, improved fertility, and enhanced quality of life." },
    ],
  },
  {
    slug: "low-amh-ayurveda",
    title: "Low AMH: Can Ayurveda Help Improve Fertility?",
    excerpt: "Low AMH indicates reduced ovarian reserve — not the end of your fertility journey. Understand what AMH means and how Ayurveda supports reproductive health.",
    date: "Mar 5, 2026",
    read: "11 min read",
    tag: "Fertility",
    cover: "https://customer-assets.emergentagent.com/job_clinic-builder-13/artifacts/lsfnceyy_file_0000000092bc71f7aaa3bf073620e9f4.png",
    fromOwner: true,
    body: [
      { type: "p", text: "Many women feel anxious after hearing they have Low AMH (Anti-Müllerian Hormone). While Low AMH indicates a reduced ovarian reserve, it does not mean pregnancy is impossible. Many women with Low AMH conceive naturally or with appropriate fertility treatment." },
      { type: "p", text: "Ayurveda focuses not just on hormone levels but on improving the overall quality of reproductive health, strengthening the body, and preparing it for healthy conception." },
      { type: "p", text: "In this article, let's understand Low AMH and how Ayurveda may support fertility naturally." },

      { type: "h2", text: "What is AMH?" },
      { type: "p", text: "Anti-Müllerian Hormone (AMH) is produced by the small follicles present in the ovaries. It is considered an indicator of ovarian reserve, which means the estimated number of eggs remaining in the ovaries." },

      { type: "h2", text: "General AMH Levels" },
      { type: "ul", items: [
        "Above 3.0 ng/mL — High ovarian reserve",
        "1.0–3.0 ng/mL — Normal ovarian reserve",
        "0.7–0.9 ng/mL — Low-normal reserve",
        "Below 0.7 ng/mL — Low ovarian reserve",
      ]},
      { type: "p", text: "These ranges vary slightly between laboratories and should always be interpreted by a fertility specialist in the context of age and other investigations." },

      { type: "h2", text: "Does Low AMH Mean You Cannot Get Pregnant?" },
      { type: "p", text: "No. AMH reflects the quantity of eggs, not necessarily the quality. A woman with Low AMH may:" },
      { type: "ul", items: [
        "Ovulate regularly",
        "Have healthy eggs",
        "Conceive naturally",
        "Respond to fertility treatment, although fewer eggs may be retrieved during IVF",
      ]},
      { type: "p", text: "Age remains one of the most important factors affecting egg quality." },

      { type: "h2", text: "Symptoms of Low AMH" },
      { type: "p", text: "Low AMH itself usually does not cause symptoms. It is often detected during fertility evaluation. Some women may experience:" },
      { type: "ul", items: [
        "Difficulty conceiving",
        "Reduced fertility",
        "Shorter menstrual cycles",
        "Poor ovarian response during fertility treatment",
        "Early decline in ovarian function in some cases",
      ]},
      { type: "p", text: "Many women with Low AMH continue to have completely regular menstrual cycles." },

      { type: "h2", text: "Causes of Low AMH" },
      { type: "food", num: "1", name: "Increasing Age", desc: "The number of eggs naturally declines with age, especially after 35 years." },
      { type: "food", num: "2", name: "Genetic Factors", desc: "Some women are born with a naturally lower ovarian reserve." },
      { type: "food", num: "3", name: "Endometriosis", desc: "Endometriosis and ovarian endometriomas can affect ovarian reserve." },
      { type: "food", num: "4", name: "Ovarian Surgery", desc: "Removal of ovarian cysts or repeated ovarian procedures may reduce ovarian reserve." },
      { type: "food", num: "5", name: "Autoimmune Disorders", desc: "Certain autoimmune conditions can affect ovarian function." },
      { type: "food", num: "6", name: "Chemotherapy or Radiation", desc: "Cancer treatments may damage ovarian follicles." },
      { type: "food", num: "7", name: "Lifestyle Factors", desc: "Modern habits that impact ovarian reserve:",
        bullets: ["Smoking", "Chronic stress", "Poor sleep", "Nutritional deficiencies", "Obesity or being underweight"] },

      { type: "h2", text: "Ayurvedic Perspective on Low AMH" },
      { type: "p", text: "Although AMH is a modern laboratory parameter, Ayurveda understands fertility through concepts such as:" },
      { type: "ul", items: [
        "Artava Dhatu (female reproductive tissue)",
        "Beeja (ovum)",
        "Garbhashaya (uterus)",
        "Rasa Dhatu (primary nourishment)",
        "Ojas (vital essence supporting overall health and reproduction)",
      ]},
      { type: "p", text: "Low ovarian reserve may be associated with:" },
      { type: "ul", items: [
        "Vata imbalance, particularly Apana Vata",
        "Dhatu Kshaya (depletion of body tissues)",
        "Reduced nourishment of reproductive tissues",
        "Agni imbalance leading to poor tissue formation",
        "Chronic stress affecting hormonal balance",
      ]},
      { type: "p", text: "Ayurvedic treatment aims to improve the body's internal environment rather than focusing solely on increasing AMH values." },

      { type: "h2", text: "Can Ayurveda Increase AMH?" },
      { type: "p", text: "Current scientific evidence does not confirm that Ayurveda can consistently increase AMH levels. However, Ayurveda may help by:" },
      { type: "ul", items: [
        "Supporting healthy ovulation",
        "Improving menstrual health",
        "Enhancing reproductive tissue nourishment",
        "Reducing stress",
        "Correcting digestive and metabolic imbalances",
        "Promoting overall reproductive wellness",
      ]},
      { type: "p", text: "The primary goal is to optimize fertility potential rather than treating a laboratory number alone." },

      { type: "h2", text: "Ayurvedic Treatment Approach" },
      { type: "p", text: "Treatment is individualized after assessing your constitution (Prakriti), Dosha imbalance, age, menstrual history, and fertility evaluation." },
      { type: "food", num: "1", name: "Personalized Herbal Medicines", desc: "Depending on the individual, Ayurvedic physicians may prescribe classical formulations to support reproductive health and tissue nourishment. Self-medication should be avoided." },
      { type: "food", num: "2", name: "Panchakarma (When Appropriate)", desc: "Selected therapies may help improve overall health, reduce dosha imbalance, and prepare the body before conception. These are recommended only after a proper clinical assessment." },
      { type: "food", num: "3", name: "Diet (Ahara)", desc: "Nutrition tailored for reproductive tissue nourishment." },
      { type: "season", name: "Diet for Low AMH", icon: "Utensils",
        eat: ["Fresh home-cooked meals", "Milk (if tolerated)", "Ghee in moderation", "Seasonal fruits", "Dates", "Figs", "Almonds", "Sesame seeds", "Pumpkin seeds", "Whole grains", "Green leafy vegetables", "Protein-rich foods"],
        avoid: ["Junk food", "Processed foods", "Excess sugar", "Smoking", "Excess alcohol", "Frequent fasting"] },

      { type: "h2", text: "Lifestyle Recommendations" },
      { type: "p", text: "Healthy habits play an important role in fertility." },
      { type: "ul", items: [
        "Maintain an ideal body weight.",
        "Sleep for 7–8 hours each night.",
        "Exercise regularly but avoid overtraining.",
        "Practice yoga and meditation.",
        "Manage stress effectively.",
        "Stay physically active.",
        "Avoid smoking and recreational drugs.",
      ]},

      { type: "h2", text: "Yoga That May Support Fertility" },
      { type: "p", text: "Under professional guidance, practices such as:" },
      { type: "ul", items: ["Baddha Konasana", "Bhujangasana", "Setu Bandhasana", "Viparita Karani", "Pranayama", "Meditation"] },
      { type: "p", text: "may support general health and stress reduction, which can be beneficial during fertility planning." },

      { type: "h2", text: "Additional Fertility Evaluation" },
      { type: "p", text: "Low AMH is only one part of fertility assessment. Your doctor may also recommend:" },
      { type: "ul", items: [
        "Antral Follicle Count (AFC)",
        "FSH and LH",
        "Estradiol",
        "Thyroid profile (TSH)",
        "Prolactin",
        "Vitamin D",
        "Blood sugar evaluation",
        "Semen analysis (partner)",
        "Tubal patency tests, when indicated",
      ]},

      { type: "h2", text: "Success Tips for Women with Low AMH" },
      { type: "ul", items: [
        "Do not delay fertility planning, especially after age 35.",
        "Seek evaluation early if pregnancy is not occurring.",
        "Follow a healthy diet and lifestyle.",
        "Manage stress effectively.",
        "Maintain a healthy body weight.",
        "Follow your doctor's treatment consistently.",
        "Do not rely solely on AMH values to predict your chances of pregnancy.",
        "Combine appropriate modern fertility evaluation with evidence-informed Ayurvedic care under qualified professionals.",
      ]},

      { type: "h2", text: "When Should You Consult a Fertility Specialist?" },
      { type: "p", text: "Seek medical advice if:" },
      { type: "warn_list", items: [
        "You are under 35 and have not conceived after 12 months of trying.",
        "You are 35 or older and have not conceived after 6 months.",
        "Your AMH is reported as low.",
        "You have irregular periods.",
        "You have endometriosis or previous ovarian surgery.",
        "You have had repeated miscarriages.",
        "There is a known male factor affecting fertility.",
      ]},

      { type: "h2", text: "Final Thoughts" },
      { type: "p", text: "A diagnosis of Low AMH can feel overwhelming, but it should not be viewed as the end of your fertility journey. AMH estimates ovarian reserve, not your ability to become pregnant. Many women with Low AMH achieve successful pregnancies with timely evaluation and appropriate care." },
      { type: "p", text: "Ayurveda offers a holistic approach by supporting reproductive health through individualized treatment, nutrition, lifestyle measures, and stress management. While it should not be considered a proven method to increase AMH levels, it may complement conventional fertility care by improving overall well-being and optimizing the conditions for conception." },

      { type: "disclaimer", text: "This article is for educational purposes only and should not replace medical advice. Always consult a qualified gynecologist or fertility specialist before starting any treatment." },
    ],
  },
  {
    slug: "pcos-myths",
    title: "7 Common Myths About PCOS You Should Stop Believing",
    excerpt: "PCOS is surrounded by misinformation that delays diagnosis and treatment. Here are 7 common myths and the science + Ayurveda behind the real facts.",
    date: "Mar 1, 2026",
    read: "12 min read",
    tag: "PCOS",
    cover: "https://customer-assets.emergentagent.com/job_clinic-builder-13/artifacts/niaar0b1_file_00000000bf4471f59929d4a79bc48bcc.png",
    fromOwner: true,
    body: [
      { type: "p", text: "Polycystic Ovary Syndrome (PCOS) is one of the most common hormonal disorders affecting women of reproductive age. It can cause irregular periods, acne, weight gain, excess facial hair, difficulty conceiving, and metabolic issues. Unfortunately, many women receive misleading information about PCOS, which can delay proper diagnosis and treatment." },
      { type: "p", text: "Understanding the facts can help women make informed decisions about their health. Ayurveda also offers a holistic approach that complements modern medical care by focusing on improving overall health rather than just managing symptoms." },
      { type: "p", text: "Let's explore seven common myths about PCOS and the truth behind them." },

      { type: "myth", num: "1", title: "PCOS Only Affects Overweight Women",
        fact: ["Women of all body types can have PCOS. While many women with PCOS are overweight due to insulin resistance, a significant number have lean PCOS, where body weight remains normal despite hormonal imbalance."],
        scientific: [
          "PCOS develops due to a combination of:",
          { bullets: ["Hormonal imbalance", "Insulin resistance", "Genetic predisposition", "Chronic low-grade inflammation"] },
          "These factors can occur regardless of body weight.",
        ],
        ayurvedic: [
          "Ayurveda does not classify diseases solely based on weight. Different body constitutions (Prakriti) respond differently. Lean women may primarily have Vata-Pitta imbalance, while overweight women often show Kapha predominance with impaired metabolism (Agni).",
          "Treatment is individualized according to each woman's constitution and symptoms.",
        ],
      },

      { type: "myth", num: "2", title: "Women with PCOS Cannot Get Pregnant",
        fact: [
          "PCOS does not mean infertility. It simply means ovulation may occur irregularly, making conception more challenging — but certainly possible.",
          "Many women with PCOS conceive naturally or with appropriate treatment.",
        ],
        scientific: [
          "PCOS commonly causes:",
          { bullets: ["Delayed ovulation", "Anovulation", "Hormonal imbalance"] },
          "Once ovulation improves through lifestyle changes or medical treatment, pregnancy chances often increase significantly.",
        ],
        ayurvedic: [
          "Ayurveda aims to:",
          { bullets: ["Improve ovulation", "Balance hormones naturally", "Enhance reproductive tissue (Artava Dhatu)", "Improve uterine health", "Reduce stress"] },
          "By correcting the root imbalance, fertility may improve naturally in suitable cases.",
        ],
      },

      { type: "myth", num: "3", title: "Irregular Periods Are Normal in PCOS",
        fact: [
          "Irregular periods are common in PCOS but should never be ignored. Skipping periods for several months increases the risk of:",
          { bullets: ["Endometrial thickening", "Heavy bleeding", "Endometrial hyperplasia", "Long-term uterine complications"] },
        ],
        scientific: [
          "Without regular ovulation, progesterone levels remain low, causing continuous estrogen stimulation of the uterine lining.",
          "This is why regular menstrual cycles are important.",
        ],
        ayurvedic: [
          "Ayurveda considers regular menstruation an important sign of healthy reproductive function. Treatment focuses on restoring a balanced menstrual cycle rather than simply inducing withdrawal bleeding.",
        ],
      },

      { type: "myth", num: "4", title: "Birth Control Pills Cure PCOS",
        fact: [
          "Birth control pills help manage symptoms but do not cure PCOS.",
          "Symptoms often return after stopping the medication if the underlying causes remain untreated.",
        ],
        scientific: [
          "Oral contraceptive pills:",
          { bullets: ["Regulate menstrual bleeding", "Reduce acne", "Lower androgen levels", "Improve excess hair growth"] },
          "However, they do not eliminate insulin resistance or permanently restore normal ovulation.",
        ],
        ayurvedic: [
          "Ayurveda emphasizes correcting the root cause by improving metabolism, hormonal balance, digestion, and lifestyle rather than only suppressing symptoms.",
        ],
      },

      { type: "myth", num: "5", title: "Weight Loss Alone Will Cure PCOS",
        fact: [
          "Weight loss can significantly improve symptoms, but it is not a complete cure.",
          "Some women remain symptomatic even after losing weight.",
        ],
        scientific: [
          "PCOS involves multiple factors including:",
          { bullets: ["Genetics", "Hormonal imbalance", "Insulin resistance", "Inflammation", "Stress"] },
          "Weight management is only one part of treatment.",
        ],
        ayurvedic: [
          "Ayurveda focuses on:",
          { bullets: ["Healthy digestion (Agni)", "Balanced Doshas", "Proper sleep", "Stress reduction", "Nutritious diet", "Regular exercise"] },
          "Overall lifestyle correction is considered more important than weight loss alone.",
        ],
      },

      { type: "myth", num: "6", title: "PCOS Is Only a Reproductive Problem",
        fact: [
          "PCOS affects the entire body. It can increase the risk of:",
          { bullets: ["Type 2 diabetes", "High cholesterol", "High blood pressure", "Fatty liver", "Sleep apnea", "Anxiety", "Depression", "Heart disease"] },
        ],
        scientific: [
          "Insulin resistance plays a major role in many of these complications.",
          "Regular health check-ups help prevent long-term problems.",
        ],
        ayurvedic: [
          "Ayurveda views PCOS as a systemic imbalance involving metabolism, digestion, hormonal regulation, and mental well-being. Therefore, treatment includes dietary guidance, daily routine, stress management, and herbal support alongside reproductive care.",
        ],
      },

      { type: "myth", num: "7", title: "There Is No Natural Way to Manage PCOS",
        fact: [
          "Lifestyle changes are considered the first line of management for many women with PCOS.",
        ],
        scientific: [
          "Research shows that:",
          { bullets: ["Regular physical activity", "Healthy nutrition", "Weight management (when needed)", "Good sleep", "Stress reduction"] },
          "can improve insulin sensitivity, regulate menstrual cycles, and support ovulation in many women.",
        ],
        ayurvedic: [
          "Ayurveda supports natural management through:",
          { bullets: ["Personalized dietary recommendations", "Daily routines (Dinacharya)", "Yoga and pranayama", "Stress management", "Appropriate herbal formulations prescribed by a qualified Ayurvedic physician", "Panchakarma therapies in selected patients, when clinically appropriate"] },
          "Treatment should always be individualized rather than self-prescribed.",
        ],
      },

      { type: "h2", text: "Common Symptoms of PCOS" },
      { type: "p", text: "Women with PCOS may experience:" },
      { type: "ul", items: [
        "Irregular or missed periods",
        "Acne",
        "Excess facial or body hair",
        "Hair thinning",
        "Weight gain or difficulty losing weight",
        "Dark pigmentation around the neck or underarms",
        "Difficulty conceiving",
        "Mood changes",
        "Fatigue",
      ]},
      { type: "p", text: "If these symptoms persist, seek medical evaluation for proper diagnosis." },

      { type: "h2", text: "Tips to Manage PCOS Naturally" },
      { type: "ul", items: [
        "Eat a balanced diet rich in vegetables, whole grains, lean proteins, and healthy fats.",
        "Exercise for at least 30 minutes on most days.",
        "Maintain a healthy weight if advised by your doctor.",
        "Sleep 7–8 hours every night.",
        "Practice yoga, meditation, or breathing exercises to reduce stress.",
        "Avoid smoking and limit highly processed, sugary foods.",
        "Follow treatment recommended by your healthcare provider and attend regular follow-up visits.",
      ]},

      { type: "h2", text: "When Should You Consult a Doctor?" },
      { type: "p", text: "Consult a gynecologist if you have:" },
      { type: "warn_list", items: [
        "No periods for more than three months",
        "Very irregular menstrual cycles",
        "Difficulty conceiving after trying for pregnancy",
        "Excess facial hair or severe acne",
        "Rapid weight gain",
        "Persistent pelvic pain",
        "Symptoms suggestive of diabetes, such as increased thirst or frequent urination",
      ]},
      { type: "p", text: "Early diagnosis and treatment can help reduce complications and improve long-term health." },

      { type: "h2", text: "Conclusion" },
      { type: "p", text: "PCOS is a manageable condition, and many misconceptions surrounding it can create unnecessary fear or delay treatment. Understanding the facts empowers women to take proactive steps toward better hormonal and reproductive health." },
      { type: "p", text: "A combination of evidence-based medical care, healthy lifestyle changes, and individualized Ayurvedic management may help improve symptoms and overall well-being. Because PCOS varies from person to person, treatment should always be tailored to the individual's needs." },

      { type: "disclaimer", text: "This article is intended for educational purposes only and should not replace professional medical advice, diagnosis, or treatment. Always consult a qualified healthcare professional before starting any new treatment or herbal medication." },
    ],
  },
  {
    slug: "ayurveda-fertility-naturally",
    title: "How Ayurveda Helps Improve Fertility Naturally",
    excerpt: "A holistic Ayurvedic approach to fertility — Panchakarma, herbs, diet and lifestyle that address the four pillars: Ritu, Kshetra, Ambu, and Beeja.",
    date: "Feb 25, 2026",
    read: "13 min read",
    tag: "Fertility",
    cover: "https://customer-assets.emergentagent.com/job_clinic-builder-13/artifacts/iyt8504f_file_00000000e9c071f78fc413f01dc7402c.png",
    fromOwner: true,
    body: [
      { type: "p", text: "Bringing a new life into the world is a cherished dream for many couples. However, infertility has become increasingly common due to stress, hormonal imbalance, unhealthy lifestyle, delayed marriage, poor diet, environmental toxins, and medical conditions like PCOS and endometriosis." },
      { type: "p", text: "According to the World Health Organization (WHO), infertility affects approximately 1 in 6 couples globally. While modern medicine offers several treatment options, many couples seek a natural and holistic approach that addresses the root cause rather than simply managing symptoms." },
      { type: "p", text: "Ayurveda, India's ancient system of medicine, focuses on restoring the body's natural balance to enhance fertility naturally. Rather than treating fertility as an isolated issue, Ayurveda aims to optimize overall health, reproductive function, digestion, mental well-being, and hormonal balance." },

      { type: "h2", text: "Understanding Female Infertility" },
      { type: "p", text: "Female infertility means difficulty in conceiving despite regular unprotected intercourse for:" },
      { type: "ul", items: [
        "12 months if the woman is under 35 years",
        "6 months if she is 35 years or older",
      ]},
      { type: "p", text: "Infertility is often multifactorial, involving hormonal, structural, metabolic, or lifestyle-related causes." },

      { type: "h2", text: "Common Causes of Female Infertility" },
      { type: "food", num: "1", name: "Ovulation Disorders", desc: "Irregular or absent ovulation is one of the leading causes of infertility. Common conditions include:",
        bullets: ["PCOS (Polycystic Ovary Syndrome)", "Hormonal imbalance", "Premature ovarian insufficiency", "Thyroid disorders", "Hyperprolactinemia"] },
      { type: "food", num: "2", name: "Poor Egg Quality", desc: "Increasing maternal age may reduce:",
        bullets: ["Egg quality", "Ovarian reserve", "Fertilization potential"] },
      { type: "food", num: "3", name: "Blocked Fallopian Tubes", desc: "Tubes may become blocked due to:",
        bullets: ["Pelvic infections", "Tuberculosis", "Endometriosis", "Previous surgeries"] },
      { type: "food", num: "4", name: "Endometriosis", desc: "Endometriosis can cause:",
        bullets: ["Severe pain", "Inflammation", "Adhesions", "Reduced fertility"] },
      { type: "food", num: "5", name: "Uterine Problems", desc: "Examples include:",
        bullets: ["Fibroids", "Polyps", "Congenital abnormalities", "Thin endometrium"] },
      { type: "food", num: "6", name: "Lifestyle Factors", desc: "Modern lifestyle risk factors:",
        bullets: ["Obesity", "Underweight", "Smoking", "Alcohol", "Poor sleep", "Chronic stress", "Sedentary lifestyle"] },

      { type: "h2", text: "Fertility According to Ayurveda" },
      { type: "p", text: "Ayurveda describes successful conception as depending upon four essential factors:" },
      { type: "food", num: "1", name: "Ritu", desc: "Proper timing and healthy ovulation." },
      { type: "food", num: "2", name: "Kshetra", desc: "A healthy uterus and reproductive tract." },
      { type: "food", num: "3", name: "Ambu", desc: "Proper nourishment through healthy digestion and circulation." },
      { type: "food", num: "4", name: "Beeja", desc: "Healthy ovum and sperm." },
      { type: "p", text: "When any of these factors are disturbed due to imbalance of Vata, Pitta, or Kapha, fertility may decline. Ayurvedic treatment aims to restore these four pillars naturally." },

      { type: "h2", text: "Importance of Preconception Care" },
      { type: "p", text: "Ayurveda strongly recommends preparing the body before pregnancy. Preconception care improves:" },
      { type: "ul", items: ["Egg quality", "Hormonal balance", "Ovulation", "Uterine health", "Mental well-being", "Nutritional status"] },
      { type: "p", text: "Preparing the body before conception supports a healthier pregnancy and may contribute to better fetal development." },

      { type: "h2", text: "Panchakarma for Fertility" },
      { type: "p", text: "One of Ayurveda's unique strengths is Panchakarma, a detoxification and rejuvenation therapy. Panchakarma helps remove accumulated toxins (Ama), improve metabolism, and restore dosha balance. It is always individualized and should be performed under the supervision of a qualified Ayurvedic physician." },
      { type: "p", text: "Potential benefits include:" },
      { type: "ul", items: ["Improved hormonal balance", "Better ovarian function", "Enhanced uterine receptivity", "Improved digestion and metabolism", "Reduced inflammation", "Better menstrual regularity", "Stress reduction"] },
      { type: "p", text: "Common therapies may include:" },
      { type: "ul", items: ["Snehana (oleation)", "Swedana (sudation)", "Virechana (therapeutic purgation)", "Basti (medicated enema)", "Uttara Basti (in selected gynecological cases, when clinically appropriate)"] },
      { type: "p", text: "The choice of therapy depends on the patient's condition and is not the same for everyone." },

      { type: "h2", text: "Fertility-Enhancing Herbs in Ayurveda" },
      { type: "p", text: "Ayurvedic medicines should always be prescribed based on an individual's constitution (Prakriti), imbalance (Vikriti), and medical condition. Commonly used herbs include:" },
      { type: "food", num: "1", name: "Shatavari", desc: "Asparagus racemosus — traditionally used to support female reproductive health and hormonal balance." },
      { type: "food", num: "2", name: "Ashwagandha", desc: "Withania somnifera — helps manage stress and supports overall vitality." },
      { type: "food", num: "3", name: "Guduchi", desc: "Tinospora cordifolia — supports immunity and helps maintain metabolic balance." },
      { type: "food", num: "4", name: "Lodhra", desc: "Symplocos racemosa — traditionally used in menstrual and uterine health." },
      { type: "food", num: "5", name: "Gokshura", desc: "Tribulus terrestris — used in reproductive health and urinary wellness." },
      { type: "food", num: "6", name: "Phala Ghrita", desc: "A classical Ayurvedic medicated ghee traditionally used in fertility care under medical supervision." },
      { type: "disclaimer", text: "Do not self-medicate. Herbal medicines should be taken only after consultation with a qualified Ayurvedic doctor." },

      { type: "h2", text: "Diet for Better Fertility" },
      { type: "p", text: "A balanced diet plays a vital role in reproductive health. Good digestion (Agni) is essential in Ayurveda because proper nourishment supports healthy reproductive tissues (Shukra Dhatu and Artava)." },
      { type: "season", name: "Fertility Diet", icon: "Utensils",
        eat: ["Fresh seasonal fruits", "Green leafy vegetables", "Whole grains", "Moong dal", "Cow's ghee (when appropriate)", "Milk (if suitable)", "Nuts and seeds", "Fresh homemade meals", "Adequate hydration"],
        avoid: ["Processed foods", "Excess sugar", "Deep-fried foods", "Soft drinks", "Excess caffeine", "Smoking and alcohol"] },

      { type: "h2", text: "Lifestyle Tips to Improve Fertility Naturally" },
      { type: "p", text: "Healthy daily habits can significantly support fertility." },
      { type: "ul", items: [
        "Maintain a healthy body weight.",
        "Exercise moderately for 30–45 minutes most days.",
        "Practice yoga and stretching.",
        "Include pranayama and meditation to reduce stress.",
        "Sleep for 7–8 hours every night.",
        "Eat meals at regular times.",
        "Avoid excessive screen time before bed.",
        "Stay physically active.",
        "Follow your treatment plan consistently.",
      ]},

      { type: "h2", text: "Stress and Fertility" },
      { type: "p", text: "Chronic stress may influence hormonal regulation and menstrual cycles. Ayurveda addresses both physical and mental health through:" },
      { type: "ul", items: ["Meditation", "Yoga", "Pranayama", "Herbal support (when indicated)", "Daily routine (Dinacharya)", "Mindful eating and sleep habits"] },
      { type: "p", text: "Reducing stress can help improve overall well-being and support reproductive health." },

      { type: "h2", text: "When Should You Consult an Ayurvedic Fertility Specialist?" },
      { type: "p", text: "Seek evaluation if you have:" },
      { type: "warn_list", items: [
        "Irregular or absent periods",
        "PCOS",
        "Endometriosis",
        "Recurrent miscarriages",
        "Painful periods",
        "Delayed conception",
        "Hormonal imbalance",
        "Thyroid disorders affecting menstrual health",
        "Poor ovarian reserve",
        "Failed attempts to conceive despite regular intercourse",
      ]},
      { type: "p", text: "Early assessment can help identify contributing factors and guide appropriate treatment." },

      { type: "h2", text: "Can Ayurveda Be Combined with Modern Fertility Treatment?" },
      { type: "p", text: "Yes. In many cases, Ayurveda may be used alongside conventional fertility care to support overall health, provided both treating physicians are informed and treatment is coordinated. Always discuss any herbal medicines or therapies with your healthcare providers." },

      { type: "h2", text: "Conclusion" },
      { type: "p", text: "Ayurveda offers a comprehensive, individualized approach to fertility by focusing on the root causes rather than symptoms alone. Through personalized treatment, Panchakarma (when appropriate), herbal support, balanced nutrition, stress management, and healthy lifestyle practices, Ayurveda aims to optimize reproductive health and prepare the body for conception." },
      { type: "p", text: "Every fertility journey is unique. If you have been trying to conceive without success or are planning a healthy pregnancy, consulting a qualified Ayurvedic gynecologist can help you receive a treatment plan tailored to your specific needs." },

      { type: "h2", text: "Frequently Asked Questions" },
      { type: "faq", q: "Can Ayurveda help in PCOS-related infertility?", a: "Ayurveda may help support menstrual regularity, metabolic health, and ovulation in women with PCOS through individualized treatment, diet, lifestyle, and appropriate therapies." },
      { type: "faq", q: "How long does Ayurvedic fertility treatment take?", a: "The duration varies depending on the underlying cause, age, overall health, and individual response to treatment." },
      { type: "faq", q: "Is Panchakarma necessary for everyone?", a: "No. Panchakarma is recommended only when indicated after a detailed clinical assessment." },
      { type: "faq", q: "Can I take Ayurvedic herbs on my own?", a: "No. Fertility medicines should be prescribed by a qualified Ayurvedic physician after evaluating your health and medical history." },
      { type: "faq", q: "Does Ayurveda guarantee pregnancy?", a: "No medical system can guarantee pregnancy. Ayurveda aims to improve reproductive health and address underlying factors that may affect fertility, but outcomes vary from person to person." },
    ],
  },
  {
    slug: "irregular-periods-ayurveda",
    title: "Irregular Periods: Causes, Symptoms & Ayurvedic Treatment",
    excerpt: "Menstrual cycles reflect a woman's overall health. Learn common causes of irregular periods, the Ayurvedic understanding by Dosha, when to consult, and how to manage naturally.",
    date: "Feb 20, 2026",
    read: "12 min read",
    tag: "Menstrual Health",
    cover: "https://customer-assets.emergentagent.com/job_clinic-builder-13/artifacts/9z5tnbaw_file_0000000091dc71f5ad15b260ec2e3094.png",
    fromOwner: true,
    body: [
      { type: "p", text: "Menstrual cycles are an important indicator of a woman's overall health. While occasional changes in the timing of periods are common due to stress or lifestyle changes, consistently irregular periods may indicate an underlying health condition that requires proper evaluation." },
      { type: "p", text: "Ayurveda considers menstruation (Artava) to be a reflection of the balance of the body's Doshas, healthy digestion (Agni), proper tissue nourishment (Dhatu), and a calm mind. Instead of only controlling symptoms, Ayurvedic treatment aims to identify and correct the root cause." },

      { type: "h2", text: "What Are Irregular Periods?" },
      { type: "p", text: "A normal menstrual cycle usually ranges from 21 to 35 days, with bleeding lasting 2 to 7 days. Periods are considered irregular if you experience:" },
      { type: "ul", items: [
        "Cycles shorter than 21 days or longer than 35 days",
        "Missed periods for several months (Amenorrhea)",
        "Periods occurring at unpredictable intervals",
        "Very heavy or very light bleeding",
        "Spotting between periods",
        "Bleeding lasting more than 7 days",
        "Significant variation in cycle length every month",
      ]},

      { type: "h2", text: "Common Causes of Irregular Periods" },

      { type: "food", num: "1", name: "Polycystic Ovary Syndrome (PCOS)", desc: "PCOS is one of the leading causes of irregular periods. Common symptoms include:",
        bullets: ["Delayed or absent periods", "Weight gain", "Acne", "Excess facial or body hair", "Difficulty conceiving"],
        tag: "Ayurvedic view", tagText: "Many PCOS cases are associated with Kapha-Vata imbalance, impaired metabolism (Mandagni), and obstruction of the reproductive channels (Artavavaha Srotas)." },

      { type: "food", num: "2", name: "Stress and Anxiety", desc: "Emotional stress affects the hormones that regulate ovulation. Common signs:",
        bullets: ["Delayed periods", "Missed periods", "Light bleeding", "Mood changes"],
        tag: "Ayurvedic view", tagText: "Aggravation of Vata Dosha disturbs the natural menstrual rhythm." },

      { type: "food", num: "3", name: "Thyroid Disorders", desc: "Both hypothyroidism and hyperthyroidism can affect menstrual health:",
        bullets: ["Irregular periods", "Heavy or scanty bleeding", "Fertility problems", "Weight changes", "Fatigue"] },

      { type: "food", num: "4", name: "Sudden Weight Gain or Weight Loss", desc: "Rapid changes in body weight influence hormone production. Common reasons include:",
        bullets: ["Crash dieting", "Eating disorders", "Obesity", "Excessive gym workouts", "Poor nutrition"] },

      { type: "food", num: "5", name: "Excessive Exercise", desc: "Very intense physical activity may suppress ovulation. Common in:",
        bullets: ["Athletes", "Marathon runners", "Professional dancers", "Women following extreme fitness routines"] },

      { type: "food", num: "6", name: "Pregnancy", desc: "Missing a period may simply be the first sign of pregnancy. If sexually active and your period is delayed, take a pregnancy test before assuming another cause." },

      { type: "food", num: "7", name: "Perimenopause", desc: "Women above 40 years may experience irregular periods as estrogen levels fluctuate before menopause. Symptoms include:",
        bullets: ["Hot flashes", "Night sweats", "Mood swings", "Sleep disturbances"] },

      { type: "food", num: "8", name: "Other Medical Conditions", desc: "Irregular periods may also occur due to:",
        bullets: ["High prolactin levels", "Diabetes", "Chronic illnesses", "Ovarian insufficiency", "Certain medications", "Uterine disorders"] },

      { type: "h2", text: "Symptoms Associated with Irregular Periods" },
      { type: "p", text: "Women may experience one or more of the following:" },
      { type: "ul", items: [
        "Delayed periods", "Missed periods", "Heavy menstrual bleeding", "Very light bleeding",
        "Painful periods", "Acne", "Hair fall", "Facial hair growth",
        "Weight gain", "Mood swings", "Fatigue", "Difficulty conceiving",
      ]},

      { type: "h2", text: "Ayurvedic Understanding of Irregular Periods" },
      { type: "p", text: "According to Ayurveda, menstrual disorders develop due to imbalance in Vata, Pitta, and Kapha Doshas." },
      { type: "tips", name: "Vata Predominance", items: ["Delayed periods", "Scanty flow", "Severe cramps", "Anxiety", "Constipation"] },
      { type: "tips", name: "Pitta Predominance", items: ["Heavy bleeding", "Early periods", "Burning sensation", "Irritability", "Acne"] },
      { type: "tips", name: "Kapha Predominance", items: ["Delayed cycles", "Weight gain", "PCOS", "Thick white discharge", "Lethargy"] },
      { type: "p", text: "Treatment is individualized after assessing the Dosha imbalance, digestive strength, and overall health." },

      { type: "h2", text: "Ayurvedic Treatment Approach" },
      { type: "p", text: "An Ayurvedic gynecologist may recommend:" },
      { type: "ul", items: [
        "Personalized herbal medicines",
        "Dietary correction",
        "Lifestyle modification",
        "Panchakarma therapies (when indicated)",
        "Yoga and breathing exercises",
        "Stress management",
        "Weight management",
        "Regular follow-up to monitor progress",
      ]},
      { type: "p", text: "Treatment depends on the underlying cause and should always be tailored to the individual." },

      { type: "h2", text: "Natural Ways to Manage Irregular Periods" },
      { type: "routine_list", items: [
        { name: "Maintain a Healthy Weight", desc: "Both obesity and being underweight can disturb hormones. Aim for gradual, sustainable weight management through balanced nutrition and regular physical activity." },
        { name: "Eat a Balanced Diet", desc: "Include fresh vegetables, seasonal fruits, whole grains, lentils, healthy fats, adequate protein, iron-rich foods and plenty of water. Reduce junk food, refined sugar, fried foods and sugary drinks." },
        { name: "Exercise Regularly", desc: "Moderate exercise for 30–45 minutes most days can help improve hormonal balance and support regular ovulation." },
        { name: "Manage Stress", desc: "Meditation, yoga, deep breathing (Pranayama), adequate sleep and time outdoors help balance the menstrual cycle." },
        { name: "Sleep Well", desc: "Aim for 7–8 hours of quality sleep every night. Poor sleep may disrupt hormone production and menstrual regularity." },
        { name: "Track Your Menstrual Cycle", desc: "Maintain a menstrual calendar or use a period-tracking app to record cycle length, bleeding duration, flow, pain, mood changes and ovulation symptoms. This helps your doctor identify patterns." },
      ]},

      { type: "h2", text: "When Should You Consult a Gynecologist?" },
      { type: "p", text: "Seek medical advice if:" },
      { type: "warn_list", items: [
        "Periods stop for more than 3 months (and you are not pregnant)",
        "Cycles are consistently shorter than 21 days or longer than 35 days",
        "Bleeding is extremely heavy (soaking a pad every hour)",
        "Bleeding lasts more than 7 days",
        "Severe menstrual pain interferes with daily activities",
        "Bleeding occurs after menopause",
        "There is bleeding between periods",
        "You are trying to conceive but have irregular ovulation",
        "Irregular periods are accompanied by rapid weight gain, excessive facial hair, or severe acne",
      ]},
      { type: "p", text: "Early evaluation helps identify the cause and prevent complications." },

      { type: "h2", text: "Diagnosis" },
      { type: "p", text: "Your gynecologist may recommend:" },
      { type: "ul", items: [
        "Detailed menstrual history",
        "Physical examination",
        "Pelvic ultrasound",
        "Pregnancy test",
        "Thyroid profile",
        "Hormonal evaluation (LH, FSH, Prolactin, AMH, etc., when indicated)",
        "Blood sugar assessment",
        "Other investigations based on your symptoms",
      ]},

      { type: "h2", text: "Can Irregular Periods Affect Fertility?" },
      { type: "p", text: "Yes. Many women with irregular periods may not ovulate regularly, making it difficult to conceive. However, with timely diagnosis and appropriate treatment — whether through lifestyle changes, medical care, or Ayurveda — many women can restore regular ovulation and improve fertility outcomes." },

      { type: "h2", text: "Frequently Asked Questions" },
      { type: "faq", q: "Are irregular periods always a sign of PCOS?", a: "No. While PCOS is a common cause, thyroid disorders, stress, weight changes, pregnancy, perimenopause, and other medical conditions can also lead to irregular periods." },
      { type: "faq", q: "Can Ayurveda help regulate periods?", a: "Ayurveda aims to address the underlying imbalance through personalized diet, lifestyle, herbal medicines, and therapies. Treatment should always be prescribed by a qualified Ayurvedic physician after proper evaluation." },
      { type: "faq", q: "Can stress alone delay periods?", a: "Yes. Physical or emotional stress can interfere with ovulation, resulting in delayed or missed periods." },
      { type: "faq", q: "Should I ignore occasional irregular periods?", a: "An occasional variation may not be serious. However, persistent irregularity, heavy bleeding, severe pain, or missed periods should be evaluated by a gynecologist." },

      { type: "h2", text: "Conclusion" },
      { type: "p", text: "Irregular periods are common but should not be ignored, especially if they persist or are associated with pain, excessive bleeding, infertility, or symptoms such as weight gain and acne. Understanding the underlying cause is essential for effective treatment." },
      { type: "p", text: "Ayurveda offers a holistic approach by focusing on restoring hormonal balance, improving digestion and metabolism, supporting reproductive health, and promoting overall well-being through individualized care. If you experience persistent menstrual irregularities, consult a qualified gynecologist or Ayurvedic gynecologist for a comprehensive evaluation and personalized treatment plan." },

      { type: "disclaimer", text: "This article is intended for educational purposes only and should not replace professional medical advice, diagnosis, or treatment." },
    ],
  },
  {
    slug: "foods-hormonal-health",
    title: "Foods That Support Women's Hormonal Health According to Ayurveda",
    excerpt: "Hormonal balance begins on your plate. A complete Ayurvedic guide to the foods, herbs, routines and seasonal choices that restore women's endocrine health.",
    date: "Feb 15, 2026",
    read: "10 min read",
    tag: "Hormonal Health",
    cover: "https://customer-assets.emergentagent.com/job_clinic-builder-13/artifacts/iamp112c_file_000000007aec71f794552805810b99ed.png",
    fromOwner: true,
    body: [
      { type: "p", text: "Hormonal balance is essential for a woman's overall health. Healthy hormones influence menstrual cycles, fertility, mood, metabolism, sleep, skin, and energy levels. Modern lifestyles, irregular eating habits, stress, poor sleep, and processed foods can disrupt this delicate balance." },
      { type: "p", text: "According to Ayurveda, hormonal health depends on the balance of the three doshas — Vata, Pitta, and Kapha — along with healthy digestion (Agni) and proper nourishment of the body's tissues (Dhatus). Instead of treating hormones alone, Ayurveda aims to restore the body's natural balance." },

      { type: "h2", text: "Best Foods for Women's Hormonal Health" },

      { type: "food", num: "1", name: "Ghee", desc: "Pure cow's ghee nourishes reproductive tissues (Artava Dhatu), supports hormone production, improves digestion, and reduces Vata.", tag: "How to use", tagText: "1–2 teaspoons daily with warm meals." },
      { type: "food", num: "2", name: "Sesame Seeds", desc: "Rich in calcium, magnesium, healthy fats, and phytoestrogens, sesame seeds help regulate menstrual cycles and support bone health.", tag: "Best for", tagText: "Irregular periods and menopause." },
      { type: "food", num: "3", name: "Flaxseeds", desc: "Flaxseeds contain omega-3 fatty acids and lignans that help maintain healthy estrogen balance.", tag: "Tip", tagText: "Consume 1 tablespoon of freshly ground flaxseed daily." },
      { type: "food", num: "4", name: "Fresh Seasonal Fruits", desc: "Papaya, pomegranate, apples, berries, guava, and oranges provide antioxidants that support hormone regulation and reproductive health." },
      { type: "food", num: "5", name: "Green Leafy Vegetables", desc: "Spinach, fenugreek leaves, drumstick leaves, and amaranth provide iron, folate, calcium, and magnesium, supporting healthy ovulation and menstrual health." },
      { type: "food", num: "6", name: "Whole Grains", desc: "Millets, barley, red rice, hand-pounded rice, and oats provide steady energy while preventing blood sugar fluctuations that may worsen hormonal imbalance." },
      { type: "food", num: "7", name: "Mung Dal", desc: "Easy to digest and rich in plant protein, mung dal supports tissue repair without increasing Kapha." },
      { type: "food", num: "8", name: "Nuts", desc: "Soaked almonds and walnuts provide vitamin E, zinc, and healthy fats essential for reproductive hormones." },
      { type: "food", num: "9", name: "Shatavari", desc: "Known as the \"Queen of Herbs\" in Ayurveda, Shatavari supports female reproductive health, menstrual regularity, fertility, and menopause.", tag: "Note", tagText: "Use only under the guidance of a qualified Ayurvedic physician." },
      { type: "food", num: "10", name: "Warm Water & Herbal Teas", desc: "Warm water, cumin-coriander-fennel tea, and ginger tea support digestion, reduce bloating, and improve metabolism." },

      { type: "h2", text: "Foods to Avoid" },
      { type: "avoid_list", items: [
        { name: "Refined Sugar", desc: "Excess sugar causes insulin spikes, contributing to hormonal imbalance and PCOS." },
        { name: "Refined Flour (Maida)", desc: "Difficult to digest and promotes weight gain and inflammation." },
        { name: "Packaged & Processed Foods", desc: "Contain preservatives, unhealthy fats, and additives that may interfere with metabolism." },
        { name: "Deep-Fried Foods", desc: "Increase Kapha, slow digestion, and contribute to obesity and insulin resistance." },
        { name: "Sugary Drinks", desc: "Soft drinks, packaged juices, and energy drinks increase blood sugar rapidly." },
        { name: "Excess Dairy", desc: "Heavy dairy products may aggravate Kapha in women with PCOS or obesity. Fresh homemade curd (during the daytime only) may be suitable for some individuals." },
        { name: "Excess Caffeine", desc: "Too much coffee or tea can increase stress hormones and disturb sleep." },
        { name: "Late-Night Heavy Meals", desc: "Eating late weakens digestion and affects metabolism, leading to hormonal imbalance over time." },
      ]},

      { type: "h2", text: "Daily Ayurvedic Routine for Hormonal Balance" },
      { type: "routine_list", items: [
        { name: "Wake Up Early", desc: "Wake before sunrise or around 6:00 AM to align with the body's natural rhythm." },
        { name: "Drink Warm Water", desc: "Start the day with a glass of warm water to stimulate digestion." },
        { name: "Exercise", desc: "Practice yoga, brisk walking, or Surya Namaskar for 30–45 minutes daily." },
        { name: "Practice Pranayama", desc: "Include Anulom Vilom, Bhramari, and deep breathing to reduce stress and support endocrine health." },
        { name: "Eat Meals on Time", desc: "Maintain regular meal timings and avoid skipping breakfast." },
        { name: "Eat Freshly Cooked Food", desc: "Choose warm, homemade meals over refrigerated or processed foods." },
        { name: "Sleep Well", desc: "Aim for 7–8 hours of quality sleep and avoid staying awake late." },
        { name: "Manage Stress", desc: "Meditation, mindfulness, reading, or spending time in nature can help reduce stress, which significantly affects hormonal balance." },
      ]},

      { type: "h2", text: "Seasonal Recommendations" },
      { type: "season", name: "Summer (Grishma)", icon: "Sun",
        eat: ["Coconut water", "Pomegranate", "Cucumber", "Watermelon", "Bottle gourd", "Homemade buttermilk"],
        avoid: ["Excess spicy foods", "Fried snacks", "Carbonated drinks", "Excess coffee"] },
      { type: "season", name: "Monsoon (Varsha)", icon: "CloudRain",
        eat: ["Warm soups", "Ginger", "Garlic", "Light khichdi", "Steamed vegetables"],
        avoid: ["Raw salads", "Street food", "Cold drinks", "Heavy oily meals"] },
      { type: "season", name: "Winter (Hemanta & Shishira)", icon: "Snowflake",
        eat: ["Ghee", "Sesame seeds", "Millets", "Dry fruits", "Soups", "Seasonal vegetables"],
        avoid: ["Excess sweets", "Overeating", "Very cold foods"] },

      { type: "h2", text: "Ayurvedic Tips for Common Hormonal Problems" },
      { type: "tips", name: "PCOS", items: ["Maintain a healthy weight.", "Exercise daily.", "Limit sugar and processed foods.", "Eat high-fiber meals."] },
      { type: "tips", name: "Painful Periods", items: ["Drink warm water.", "Include anti-inflammatory spices like ginger and turmeric.", "Avoid cold foods during menstruation."] },
      { type: "tips", name: "Menopause", items: ["Include calcium-rich foods.", "Eat healthy fats.", "Practice yoga and meditation.", "Stay well hydrated."] },
      { type: "tips", name: "Fertility Planning", items: ["Eat a nutrient-rich, balanced diet.", "Maintain regular sleep.", "Avoid smoking and alcohol.", "Seek timely medical evaluation if conception is delayed."] },

      { type: "h2", text: "Final Thoughts" },
      { type: "p", text: "Ayurveda teaches that hormonal balance begins with proper digestion, balanced nutrition, regular routines, restful sleep, and a calm mind. Small, consistent lifestyle changes often have a lasting positive impact on menstrual health, fertility, and overall well-being." },

      { type: "disclaimer", text: "This article is for educational purposes only and should not replace individualized medical advice. Every woman has unique health needs. Consult a qualified Ayurvedic gynecologist before starting any herbal medicines or treatment, especially if you have PCOS, infertility, thyroid disorders, or other medical conditions." },
    ],
  },
];

export const FAQS = [
  {
    category: "PCOS",
    q: "Can PCOS be cured with Ayurveda?",
    a: "PCOS can be beautifully managed and, in many cases, brought into remission with Ayurveda. Treatment focuses on rebalancing hormones, restoring menstrual regularity, weight management and improving insulin sensitivity through personalized herbs, diet and lifestyle.",
  },
  {
    category: "PCOS",
    q: "How long does PCOS treatment take?",
    a: "Most women see cycle regularity and symptom relief within 3–4 months. A full protocol typically runs 6–9 months, followed by a maintenance phase.",
  },
  {
    category: "PCOS",
    q: "Do I need to stop my allopathic medicines?",
    a: "No. Please continue your current medication. We work alongside your existing care and taper only under medical guidance, if and when appropriate.",
  },
  {
    category: "Infertility",
    q: "We have been trying for 2 years. Can Ayurveda help?",
    a: "Absolutely. Ayurveda addresses fertility at the root — egg and sperm quality, uterine health, hormonal balance and emotional readiness. Most couples see results within 6–12 months of a structured program.",
  },
  {
    category: "Infertility",
    q: "Can Ayurveda be combined with IVF or IUI?",
    a: "Yes. Many patients use Ayurvedic preparation for 3–6 months before ART cycles. Studies and clinical experience show improved outcomes with combined care.",
  },
  {
    category: "Infertility",
    q: "What is Uttarbasti?",
    a: "Uttarbasti is a specialized Panchakarma procedure where medicated oil or decoction is administered into the uterine cavity. It is highly effective for tubal blockage, thin endometrium, and reproductive tract issues, performed under sterile conditions.",
  },
  {
    category: "Infertility",
    q: "Is male fertility also treated?",
    a: "Yes. Male factor accounts for nearly half of fertility cases. We treat sperm count, motility and morphology with Vajikarana therapy, herbs and lifestyle changes.",
  },
  {
    category: "Pregnancy",
    q: "When should I start Garbhini Paricharya?",
    a: "Ideally from the moment you know you are pregnant. Some care can begin as early as preconception. Each month has its own recommended diet, herbs and routine.",
  },
  {
    category: "Pregnancy",
    q: "Is Ayurvedic care safe during pregnancy?",
    a: "Yes, when guided by a qualified Ayurvedic gynecologist. Every herb, therapy and routine at Nari Arogya is selected specifically for pregnancy safety.",
  },
  {
    category: "Pregnancy",
    q: "What is Garbha Sanskar?",
    a: "Garbha Sanskar is the ancient science of nurturing the baby's mind, emotions and consciousness while still in the womb — through music, mantras, reading, meditation and mindful living.",
  },
  {
    category: "Pregnancy",
    q: "Do you offer post-delivery care?",
    a: "Yes. Sutika Paricharya is a 42-day recovery program with warm oil massages, herbal decoctions, restorative diet and lactation support. It builds strength for a lifetime.",
  },
  {
    category: "Ayurveda",
    q: "How is Ayurvedic diagnosis done?",
    a: "We use nadi (pulse), jihva (tongue), prashna (detailed history) and modern lab reports to understand your prakriti (constitution) and vikruti (imbalance). Diagnosis takes 45–60 minutes.",
  },
  {
    category: "Ayurveda",
    q: "Are Ayurvedic medicines safe?",
    a: "Classical Ayurvedic medicines from GMP-certified pharmacies, prescribed by a qualified Vaidya, are safe. We do not use random OTC or self-medicated products.",
  },
  {
    category: "Ayurveda",
    q: "Do I need to follow a strict diet?",
    a: "Diet is central to Ayurveda, but our recommendations are practical, realistic and delicious. You will get simple recipes and a plan tailored to your lifestyle.",
  },
  {
    category: "Ayurveda",
    q: "How is my consultation structured?",
    a: "The first consultation is 45–60 minutes: detailed history, examination, diagnosis, and a written plan. Follow-ups every 4 weeks help fine-tune your treatment.",
  },
];
